import * as UI from "../ui.js";

UI.onDataActionClick("onboarding-alert:dismiss", ({ el, target }) => {
  const alert = target ?? el.closest(".onboarding-alert");
  alert.remove();
});
